import { ReactNode, createContext, useCallback, useContext, useEffect, useState } from 'react';
import { FeaturesApi, PersonaleApi } from '../data';
import useApiConfiguration from '../apiConfig';
import { Button, LoadPanel } from 'devextreme-react';
import LogoutButton from '../components/LogoutButton';

interface User {
    id: number;
    nome: string;
    cognome: string;
    descrizione: string;
    email: string;
    isAdmin: boolean;
    isSupervisore: boolean;
    features?: string[];
}

interface UserSessionContextType {
    user: User,
    setUser: (user: User) => void;
}

const UserSessionContext = createContext<UserSessionContextType | undefined>(undefined);

export const useUserSessionContext = () => {
    const context = useContext(UserSessionContext);
    if (!context)
        throw new Error("useUserSessionContext deve essere usato all'interno di <UserSessionProvider>");

    return context;
}

export const UserSessionProvider = ({ children }: { children: ReactNode }) => {
    const apiConfiguration = useApiConfiguration();
    const [user, setUser] = useState<User>();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        (async function () {
            setLoading(true);

            try {
                
                var api = new PersonaleApi(apiConfiguration);
                var apiFeatures = new FeaturesApi(apiConfiguration);
                var response = await api.apiPersonaleMeGet();
                var resFeatures = await apiFeatures.getFeatures();

                if (response) {
                    setUser({
                        id: response.idPersonale,
                        nome: response.nome,
                        cognome: response.cognome,
                        descrizione: response.descrizione,
                        email: response.email,
                        isAdmin: response.isAdmin,
                        isSupervisore: response.isSupervisore,
                        features: resFeatures
                    });
                }
            }
            catch (error) {
                console.error("Errore durante il recupero dell'utente:", error);
                setUser(undefined);
            }
            finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <UserSessionContext.Provider value={{ user, setUser }}>
            {loading && <LoadPanel visible={true} />}
            {!loading && user && children}
            {!loading && !user && <UtenteNonValido />}
        </UserSessionContext.Provider>
    )
}

const UtenteNonValido = () => { // TODO: da spostare in un file a parte e fare graficamente più bello
    // const { signOut } = useAuthenticationContext();

    return (
        <div>
            <h1>Utente non valido</h1>
            <p>Contattare l'amministratore per abilitare l'utente.</p>

            <LogoutButton />
        </div>
    )
}
